import * as angular from "angular";
import {IController} from 'angular';

export class ConsolidatedCommissionSelectItemComponent implements IController {

  consolidatedCommission: any;

  constructor() {}

}

angular
  .module('bringoz.admin.commissions')
  .component('consolidatedCommissionSelectItem', {
    bindings: {
      consolidatedCommission: '<',
      isExcluded: '<?'
    },
    template: require('./consolidated-commission-select-item.html').default,
    controller: ConsolidatedCommissionSelectItemComponent
  });
